<!-- prettier-ignore -->

@for( message of messages(); track $index) {
  @if( message.show ){
    <div
    class="chat__message-row"
    [ngClass]="{'chat__message-row--no-animation': !isUser(message.role)}"
    >

    @if(dataChat.icon() && !isUser(message.role)){
      <div class="chat__thumbnail-wrapper" >
        <!-- <img class="chat__thumbnail" [src]="dataChat.icon()" alt="icon"> -->
         <div class="chat__thumbnail-new">
            <!-- <mini-icon-avatar /> -->
            <img class="chat__thumbnail" [src]="dataChat.icon()" alt="icon">
         </div>

      </div>
    }
      <div class="chat__message-wrapper" [ngClass]="{
        'chat__message-wrapper--user': isUser(message.role),
        'chat__message-wrapper--no-icon': !dataChat.icon() && !isUser(message.role),
      }"
      >
        <div class="chat__message"
        [ngClass]="{
          'chat__message--user': isUser(message.role),
          'chat__message--has-error': message.danger
          }"
          >

          <!-- <markdown class="markdown" linkIntercept [data]="message.content | translate" /> -->
           
          <div class="notranslate">
            <markdown class="markdown" linkIntercept [data]="message.content | translate"></markdown>
          </div>

          
        </div>

        <!-- @if(!isUser(message.role) && !message.danger){
          <div class="action-icons-container" [ngClass]="{'disabled' : isStreaming()}">
              <icon-clipboard (click)="copyToClipboard($event)"></icon-clipboard>
                @if(!checkPlayingOnDemand(message.id)){
                  @if(isLoadingAudioById() === message.id){
                    <ci-icon name="loader-debounce" scale="1x"></ci-icon>
                  } @else{
                    <icon-sound (click)="playAudio($event, errAudio)" [attr.data-tracking-id]="message.id"></icon-sound>
                  }
                }
                @else{
                  <icon-music-stop (click)="stopAudio()"></icon-music-stop>
                }
              <span class="copy-text">{{'Texto copiado' | translate }}</span>
              <span #errAudio class="error-audio">{{'Error al reproducir audio' | translate }}</span>
          </div>
        } -->
        
      </div>

    </div>

  }
}